import { Box, Container, Typography } from "@mui/material";
import React from "react";
import homeImg from "../assets/images/home.gif";
import homeImgPng from "../assets/images/homePng.png";

const HomePage = () => {
    return (
        <div>
            <Container
                sx={{
                    justifyContent: "center",
                    alignItems: "center",
                    display: "flex",
                    height: "75vh"
                }}
            >
                <Box sx={{ textAlign: "center" }}>
                    {/* <img src={homeImgPng} width={"400px"} /> */}

                    <img src={homeImg} width={"400px"} />
                    <Typography
                        variant="h4"
                        mb={1}
                        mt={1}
                        sx={{
                            fontWeight: 200,
                            color: " #0070ba",
                            paddingLeft: "20px"
                        }}
                    >
                        Work in progress, <br />
                        precision takes time.
                    </Typography>
                </Box>
            </Container>
        </div>
    );
};

export default HomePage;
